LoginController.$inject = ["LoginServices", "$http", "$state", "$auth", "$oidc"];

function LoginController(LoginServices, http, state, auth, oidc) {
    var self = this;

    self.title = "jlh";

    self.loginWithTinet = loginWithTinet;
    self.user = {
        captchaId: null
    };

    self.getCaptcha = async function () {
        let parameter = {
            type: "captcha",
            id: self.user.captchaId
        };

        await LoginServices.get(parameter).$promise.then(
            response => {
                self.captchaImage = "data:image/png;base64," + response.content.captchaImage;
                self.user.captchaId = response.content.captchaId;
            },
            errResponse => {
                iziToast.show({
                    message: errResponse.data.message,
                    theme: "light",
                    color: "red"
                });
                console.log("fail createYear");
            }
        );
    };
    self.getCaptcha();

    const customerLogin = function (checkFirstLogin, personType) {

        iziToast.show({
            message: "شما با موفقیت وارد شدید.",
            theme: "light",
            color: "green"
        });
        if (personType == 'LegalPerson') {
            if (checkFirstLogin == true) {
                location.href = legalClientFirstLoginUrl;
            } else {
                location.href = clientNormalLoginUrl;
            }
        } else if (personType == 'IndividualPerson') {
            if (checkFirstLogin == true) {
                location.href = individualClientFirstLoginUrl;
            } else {
                location.href = clientNormalLoginUrl;
            }
        }

    };

    const managerLogin = function () {
        iziToast.show({
            message: "شما با موفقیت وارد شدید.",
            theme: "light",
            color: "green"
        });
        location.href = managerLoginUrl;
    };

    const loginHandler = function (rawResponse) {

        http.defaults.headers.common.Authorization =
            "Bearer " + rawResponse.auth_token;
        let response = rawResponse;
        if (response.userType == "Customer") {
            let query = {
                type: (response.personType == 'IndividualPerson' ? 'individualPersons' : 'legalPersons'),
                id: "self",
                routeParams: (response.personType == 'IndividualPerson' ? 'profile-image' : 'logo')
            }
            LoginServices.getLogo(query)
                .$promise.then(
                    function (responseData) {
                        if (response.personType == 'IndividualPerson') {
                            response.ProfileImageAttachment = responseData.content;
                        } else {
                            response.logo = responseData.content;
                        }

                    },
                    errResponse => {
                        console.log("error");
                    }
                )
                .finally(function (res) {
                    auth.signIn(response, false);
                    customerLogin(response.first_login, response.personType);
                });
        } else if (response.userType == "FundUser") {
            LoginServices.getAuthorizationInfo({
                id: rawResponse.id
            })
                .$promise.then(
                    function (responseData) {
                        response.groupName = responseData.content.firstGroupName;
                        response.permissions = responseData.content.permissionsNames;
                    },
                    errResponse => {
                        console.log("error");
                    }
                )
                .finally(function (res) {
                    auth.signIn(response, false);
                    managerLogin();
                });
        } else {
            iziToast.show({
                message: "شما مجوز ورود به سامانه را ندارید",
                theme: "light",
                color: "red"
            });
        }
    };

    const resendSms = async function (userId) {
        let parameter = {
            type: "Accounts",
            id: userId,
            routeParams: "VerificationCode",
            routeParams2: "resend"
        };

        await LoginServices.create(parameter, {
            userId: userId
        }).$promise.then(
            response => {
                state.go("Authentication.Verification", {
                    id: userId
                });
            },
            errResponse => {
                iziToast.show({
                    message: errResponse.data.message,
                    theme: "light",
                    color: "red"
                });
                console.log("fail createYear");
            }
        );
    };

    //check login validation
    self.login = async function (user, form) {
        if (form.$valid) {
            let parameter = {
                type: "auth",
                id: "login"
            };

            await LoginServices.create(parameter, user).$promise.then(
                response => {
                    if (response.twoFactorEnabled) //آیا نیاز به تایید ورود از طریق پیامک میباشد؟
                    {
                        state.go("Authentication.TwoFactorVerification", {
                            id: response.userId
                        });
                    } else if (!response.phoneNumberConfirm) { // زمانیکه کاربر به هر دلیلی بعد از ثبت نام اکانتش فعال نشد
                        iziToast.show({
                            message: response.message,
                            theme: "light",
                            color: "yellow"
                        });
                        state.go("Authentication.Verification", {
                            id: response.userId
                        });
                    } else
                        loginHandler(response.token);
                },
                errResponse => {
                    self.getCaptcha();
                    iziToast.show({
                        message: errResponse.data.message,
                        theme: "light",
                        color: "red"
                    });
                }
            );
        } else {
            iziToast.show({
                message: "لطفا فرم را تکمیل فرمایید.",
                theme: "light",
                color: "red"
            });
        }
    };

    self.tinetLogin = function () {
        oidc.signinRedirect();
    }
}

module.exports = ngModule => {
    ngModule.controller("LoginController", LoginController);
};